import AllCourse from './AllCourse.gql';

export default AllCourse;
